/* eslint-disable no-plusplus,no-restricted-syntax,no-shadow */
import dayjs from 'dayjs';
import { isEmpty, isNil } from 'ramda';
import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';

import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';
import { loadExcelExport } from './excelActions';

export const REQUEST = 'LOAD_WORK_TIMES_IN_PERIOD_BY_JOBS_REQUEST';
export const SUCCESS = 'LOAD_WORK_TIMES_IN_PERIOD_BY_JOBS_SUCCESS';
export const FAIL = 'LOAD_WORK_TIMES_IN_PERIOD_BY_JOBS_FAIL';

const loadWorkTimesInPeriodByJobsRequest = () => ({ type: REQUEST });
const loadWorkTimesInPeriodByJobsSuccess = (workTimesInPeriodByJobs, splitBy) => ({ type: SUCCESS, workTimesInPeriodByJobs, splitBy });
const loadWorkTimesInPeriodByJobsFail = (error) => ({ type: FAIL, error });

export function loadWorkTimesInPeriodByJobs(props = {}) {
  const opt = {
    url: 'Reports/WorkTimesInPeriodByJobs',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject(props) // '?period=2017-11-14,2017-11-14&departmentIds=&userIds=&jobIds=&workShiftIds=&wccIds='
  };

  // if (queryString !=='') {
  return (dispatch) => {
    dispatch(loadWorkTimesInPeriodByJobsRequest());
    return communicate(opt).then(({ data }) => {
      if (isNil(data.Data) || isEmpty(data.Data)) {
        toastr.error(I18n.t('NoDataAvailable'));
        dispatch(loadWorkTimesInPeriodByJobsSuccess([], props.splitBy));
      } else {
        dispatch(loadWorkTimesInPeriodByJobsSuccess(data.Data, props.splitBy));
      }
    }).catch((error) => {
      dispatch(loadWorkTimesInPeriodByJobsFail(error));
      toastrError(error);
    });
  };
}


export const loadExcel = (params) => (dispatch) => {
  const request = {
    url: 'Reports/WorkTimesInPeriodByJobsExcel',
    query: Utils.objects.getQueryStringFromObject({
      ...params,
      currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
    })
  };
  return dispatch(loadExcelExport(request));
};
